import { User as UserModel } from '../../../models';

import Preloader from '../../../utils/Preloader';
import ErrorsModal from '../../../utils/ErrorsModal';
import { TippingErrorsModal, redirectTo } from '../../../utils';
import CoreLeagueSetupView from '../../../views/CoreLeagueSetup';

const BYE_ROUNDS_IDS = JSON.parse(process.env.BYE_ROUNDS || '[]');

/**
 * @desc Core League Create View Class
 */
export default class CoreLeagueCreateView extends CoreLeagueSetupView {
	get template() {
		throw new Error("Need set template for child CoreLeagueCreateView class");
	}

	/**
	 * Create events for this UI
	 * @returns object
	 */
	events() {
		return {
			...super.events(),
			'click @ui.submit_form':  'createLeague',
			'submit @ui.league_form': 'createLeague'
		};
	}

	/**
	 * Set model events
	 * @returns object
	 */
	modelEvents() {
		return {
			'league:create:errors':  'createLeagueError',
			'league:create:success': 'createLeagueSuccess',
			'league:form:errors':    'checkFormErrors'
		};
	}

	/**
	 * Initialize view data
	 */
	async initialize() {
		this.rounds = this.getOption( 'rounds' );
		this.model.set({
			isByeRounds: BYE_ROUNDS_IDS.length > 0
		});

		Preloader.show();
		await this.fetchData();
		this.updateModel()
			.updateView();
		Preloader.hide();
	}

	/**
	 *
	 * @returns {Promise.<Object>}
	 */
	fetchData() {
		return this.rounds.fetch();
	}

	/**
	 *
	 * @returns {LeagueCreateView}
	 */
	updateModel() {
		this.model.set( {
			user: UserModel,
			name: this.getDefaultLeagueName(),
			first_name: UserModel.get( 'firstname' ),
			last_name: UserModel.get( 'lastname' ).charAt(0),
			start_round: this.rounds.first_scheduled.get('id')
		} );

		this.model.updateFormData( this.rounds, true, "", true );

		return this;
	}

	getDefaultLeagueName() {
		return UserModel.get( 'firstname' )+"'s" + ' league';
	}

	/**
	 *
	 * @param {object} element
	 * @returns {LeagueCreateView}
	 */
	createLeague( element ) {
		element.preventDefault();

		if ( !this.model.isFormErrors() ) {
			Preloader.show();

			let formData = this.model.getFormData();

			this.model.createLeague( formData );
		}

		return this;
	}

	createLeagueError( errors ) {
		Preloader.hide();
		if(window.location.pathname.includes('my-comps') 
			&& window.location.hostname.includes("tipping")){
			TippingErrorsModal.show( errors );
			return;
		}
		ErrorsModal.show( errors );
	}

	createLeagueSuccess() {
		Preloader.hide();
		let league_id = this.model.get( 'id' ),
			url       = `fantasy/league/${league_id}/invites`;

		redirectTo( url );
	}

}